/* ==========================================================================
   Homellence – P1 (Runde 32): „Passt dazu"

   Die Section rendert beim Seitenaufruf nichts. `recommendations.performed?`
   ist nur wahr, wenn die Anfrage über `routes.product_recommendations_url`
   kam – dieses Skript holt genau diese Fassung nach und setzt sie ein.

   Geholt wird erst, wenn die Stelle in Sichtweite kommt (200 px Vorlauf).
   Empfehlungen kosten eine eigene Abfrage; wer nie so weit scrollt, soll
   sie nicht bezahlen.

   Übernommen wird nur der **Inhalt** des `hl-recommendations` aus der
   Antwort, nicht das Element selbst. Andernfalls stünden zwei davon
   ineinander, und das äußere würde ein zweites Mal beobachtet.

   Kommt nichts zurück – kein Element, leerer Inhalt, Netzfehler –, bleibt
   die Section leer und damit unsichtbar. Es gibt keinen Zwischenzustand
   mit Überschrift und ohne Karten: Die Überschrift steht **in** dem
   Inhalt, der nachgeladen wird.
   ========================================================================== */
(function () {
  'use strict';

  class HlRecommendations extends HTMLElement {
    connectedCallback() {
      var url = this.getAttribute('data-url');
      if (!url || this.geholt) return;

      var self = this;

      if (!('IntersectionObserver' in window)) {
        /* Ohne Beobachter sofort holen: lieber eine Abfrage zu früh als
           eine Section, die nie erscheint. */
        this.hole(url);
        return;
      }

      this.beobachter = new IntersectionObserver(
        function (eintraege) {
          if (!eintraege[0].isIntersecting) return;
          self.beobachter.disconnect();
          self.hole(url);
        },
        { rootMargin: '200px' }
      );
      this.beobachter.observe(this);
    }

    disconnectedCallback() {
      if (this.beobachter) this.beobachter.disconnect();
    }

    hole(url) {
      if (this.geholt) return;
      this.geholt = true;

      var self = this;
      fetch(url)
        .then(function (antwort) {
          if (!antwort.ok) throw new Error(String(antwort.status));
          return antwort.text();
        })
        .then(function (text) {
          var seite = new DOMParser().parseFromString(text, 'text/html');
          var gefunden = seite.querySelector('hl-recommendations');
          if (!gefunden) return;
          var inhalt = gefunden.innerHTML.trim();
          if (!inhalt.length) return;
          self.innerHTML = inhalt;
        })
        .catch(function () {
          /* Stillschweigend leer bleiben. Eine Fehlermeldung an dieser
             Stelle wäre für den Besucher ohne Bedeutung – er hat nichts
             angefordert. */
        });
    }
  }

  if (!customElements.get('hl-recommendations')) {
    customElements.define('hl-recommendations', HlRecommendations);
  }
})();
